export default {
  'checkbox': "fa fa-check-square-o",
  'checkbox-group': "fa fa-list",
  'radio-group': "fa fa-check-circle",
  'text': "fa fa-font",
  'email': "fa fa-font",
  'password': "fa fa-font",
  'textarea': "fa fa-file-text-o",
  'select': 'fa fa-bars',
  'file': "fa fa-file-pdf-o",
  'date': "fa fa-calendar",
  'switch': "fa fa-toggle-on",
  'range': "fa fa-arrows-h",
  'header': 'fa fa-header',
  'phone': 'fa fa-phone',
  'ssn': 'fa fa-hashtag',
  'signature': 'fa fa-address-card-o',
  'text-entry': 'fa fa-comment',
  'image-upload': 'fa fa-picture-o',
  'divider': 'fa fa-window-minimize',
  'row': 'fa fa-arrows-h',
  'time': 'fa fa-clock-o',
  'number': 'fa fa-sort-numeric-asc',
  'accordion': 'fa fa-compress',
  'rating': 'fa fa-star',
  'address': 'fa fa-address-card',
  'currency': 'fa fa-usd',
  'systemid': 'fa fa-id-card',
  'select2': 'fa fa-search',
  'select_case_manager_secondary': 'fa fa-search',
  'programs-checkbox-group': 'fa fa-folder-open-o',
  'destination-account': 'fa fa-folder-open-o',
  'shared-field': 'fa fa-share-alt',
  'shared-form-preview': 'fa fa-table'
}



// WEBPACK FOOTER //
// ./src/utils/formBuilder/icons.js